import { render, staticRenderFns } from "./MenusAlbb.vue?vue&type=template&id=761d67ac&scoped=true&"
import script from "./MenusAlbb.vue?vue&type=script&lang=js&"
export * from "./MenusAlbb.vue?vue&type=script&lang=js&"
import style0 from "./MenusAlbb.vue?vue&type=style&index=0&id=761d67ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d67ac",
  null
  
)

export default component.exports